import React, { useEffect, useState } from "reactn";
import PropTypes from "prop-types";
import { PaginationWrapperStyled, PaginationStyled, PaginationArrowStyled, PaginationNumberStyled } from "./Pagination.styled";
import PaginationHooks from "../../../hooks/PaginationHooks";

const Pagination = props => {
    const { pageCount, pageSize, pageChange, align, siblingCount = 1, currentPage, isLoading } = props;
	const { ellipsis, usePagination } = PaginationHooks();
    /**
     * Sets the total number of pages
     */
    const totalPages = Math.ceil(pageCount / pageSize);

	const paginationRange = usePagination(
		currentPage,
		totalPages,
		siblingCount
	);

	let lastPage = paginationRange[paginationRange.length - 1];

    /**
     * Clicking on paging number
     */
    const onNumberClick = page => {
        pageChange(page);
    };

    /**
     * Clicking on previous button
     */
    const onPreviousClick = () => {
        if(currentPage > 1) {
            pageChange(currentPage - 1);
        }
    };

    /**
     * Clicking on next button
     */
    const onNextClick = () => {
        if(currentPage < totalPages) {
            pageChange(currentPage + 1);
        }
    };

    return (
        totalPages > 1 &&
            <PaginationWrapperStyled className={align === "left" ? "flex--justify-start" : null} style={{pointerEvents: isLoading ? "none" : "all"}}>
                <PaginationStyled aria-label="Page through Information">
                    <li>
                        <PaginationArrowStyled previous active={currentPage > 1} aria-label="Go to previous page" onClick={onPreviousClick} type="button"></PaginationArrowStyled>
                    </li>
                    {
                        paginationRange.map((pageNumber, i) => {
                            if (pageNumber === ellipsis) {
                                return <span className="ellipsis" key={i}>&#8230;</span>;
                            }

                            return (
                                <li key={i}>
                                    <PaginationNumberStyled current={pageNumber === currentPage} aria-current={pageNumber === currentPage ? "page" : null} onClick={() => onNumberClick(pageNumber)} aria-label={`Go to page ${pageNumber}`} type="button">{pageNumber}</PaginationNumberStyled>
                                </li>
                            )
                        })
                    }
                    <li>
                        <PaginationArrowStyled next active={currentPage !== lastPage} onClick={onNextClick} aria-label="Go to next page" type="button" currentPage={currentPage + 1}></PaginationArrowStyled>
                    </li>
                </PaginationStyled> 
            </PaginationWrapperStyled>
    );
};

export default Pagination;

Pagination.propTypes = {
    pageCount: PropTypes.number,
    pageSize: PropTypes.number,
    pageChange: PropTypes.func,
	align: PropTypes.string
};
